import { render, staticRenderFns } from "./CreateNewVacationContractLanding.vue?vue&type=template&id=8afde800&scoped=true"
import script from "./CreateNewVacationContractLanding.vue?vue&type=script&lang=js"
export * from "./CreateNewVacationContractLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afde800",
  null
  
)

export default component.exports